import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from '@/router'
import axios from "@axios";
import useFilterCounter from '@/components/Filters/useFiltersCount'
import useTablePagination from '@/composables/useTablePagination'
import { debounce } from 'lodash'

export default function useList(trans = {}) {
  const toast = useToast()
  const { query } = router.currentRoute;

  store.dispatch('camera_proxy/getAll');
  const cameraProxyFilter = ref([]);
  const serverType = ref(null);
  const serverFilter = ref([]);
  const tenantFilter = ref(null)
  const cameraFilter = ref([])
  const camerasTypesOptions = ref([]);
  const camerasTypesFilter = ref([]);
  const statusActiveFilter = ref(null)
  const camerasOnlineFilter = ref(null)
  const startDateFilter = ref(null)
  const endDateFilter = ref(null)
  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])
  const cameraOptions = computed(() => store.getters['camera_proxy/getSelectedItems'])

  store.dispatch('tenant/getAll')
  store.dispatch('camera_proxy/getAll', { deviceType: 'camera' })

  const tableColumns = [
    {
      label: 'actions.name',
      key: 'actions',
      sortable: false
    },
    {
      label: 'ai_analytics_servers.server',
      key: 'server.name',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.id',
      key: 'id',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.device_name',
      key: 'camera.camera.name',
      sortable: true
    },
    {
      label: 'Tipo',
      key: 'camera.camera_type',
      sortable: true
    },
    {
      label: 'Umbral - VLM',
      key: 'server.server_type',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.online',
      key: 'status',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.on_server_status',
      key: 'on_server_status',
      sortable: true
    },
    {
      label: 'ai_analytics_servers.created_at',
      key: 'created_at',
      sortable: true
    }
  ]

  // Agregar columnas adicionales si es fire_smoke
  /* if (serverType.value === 'fire_smoke') {
    tableColumns.splice(tableColumns.length - 1, 0, {
      label: 'ai_analytics_servers.fire_threshold',
      key: 'fire_threshold',
      sortable: true
    })
    tableColumns.splice(tableColumns.length - 1, 0, {
      label: 'ai_analytics_servers.smoke_threshold',
      key: 'smoke_threshold',
      sortable: true
    })
    tableColumns.splice(tableColumns.length - 1, 0, {
      label: 'ai_analytics_servers.use_local_confirmation',
      key: 'use_local_confirmation',
      sortable: true
    })
  } */

  const devicesCount = ref(0)
  const serverUuid = ref(null)

  const fetchList = (ctx, callback) => {
    store.dispatch('ai_analytics_servers/devices/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_camera_proxy: cameraFilter.value,
      cameras_online: camerasOnlineFilter.value,
      status_active: statusActiveFilter.value,
      servers: serverFilter.value,
      cameras_proxy: cameraProxyFilter.value,
      cameras_types: camerasTypesFilter.value,
      from: startDateFilter.value,
      to: endDateFilter.value,
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta ? response.meta.total : response.data.length
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans['ai_analytics_servers.fetch_error'] || 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const {
    refListTable,
    perPage,
    totalList,
    currentPage,
    searchQuery,
    sortBy,
    isSortDirDesc,
    perPageOptions,
    dataMeta,
    refetchData,
    updatePagination
  } = useTablePagination({
    fetchCallback: fetchList,
    initialPerPage: 10,
    initialSortBy: 'id',
    initialSortDesc: false
  });

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      servers: serverFilter.value,
      tenants: tenantFilter.value,
      cameras: cameraFilter.value,
      statusActive: statusActiveFilter.value,
      camerasOnline: camerasOnlineFilter.value,
      startDate: startDateFilter.value,
      endDate: endDateFilter.value,
      cameras_proxy: cameraProxyFilter.value,
      cameras_type: camerasTypesFilter.value
    };

    refetchData();
  }
  const clearSearchFilters = () => {
    serverFilter.value = [];
    tenantFilter.value = null;
    cameraFilter.value = [];
    statusActiveFilter.value = null;
    camerasOnlineFilter.value = null;
    startDateFilter.value = null;
    endDateFilter.value = null;
    cameraProxyFilter.value = [];
    camerasTypesFilter.value = [];
    filters.value = {};

    if (query.id_server) {
      router.replace({ query: {} })
    }

    buildFilters();
  }

  const getDeviceCameras = () => {
    axios.get('v1/proxy_camera/getDevicesCamera')
      .then(response => {
        const { data } = response;

        camerasTypesOptions.value = data.data.map(type => {
          let label = type.split('\\').pop();

          if (label === 'VxgCamera') {
            label = 'Omnicloud';
          }

          return {
            label,
            value: type
          }
        });
      })
      .catch(() => {
        camerasTypesOptions.value = [];
      });
  }
  // ============================================

  if (query.id_server) {
    serverFilter.value.push(Number(query.id_server));

    filters.value = {
      servers: serverFilter.value,
    }
  }

  return {
    tableColumns,
    fetchList,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refetchData,
    serverUuid,
    devicesCount,
    serverFilter,
    tenantFilter,
    cameraFilter,
    statusActiveFilter,
    camerasOnlineFilter,
    startDateFilter,
    endDateFilter,
    cameraProxyFilter,
    tenantOptions,
    cameraOptions,
    filtersCount,
    clearSearchFilters,
    buildFilters,
    refListTable,
    perPage,
    totalList,
    currentPage,
    perPageOptions,
    dataMeta,
    updatePagination,
    serverType,
    getDeviceCameras,
    camerasTypesOptions,
    camerasTypesFilter,
    filters
  }
}
